import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  // Internal signal to track loading state
  private readonly _loading = signal<boolean>(false);
  //Public readonly computed signal
  public readonly loading = computed(() => this._loading());

  // Show the loader 
  showLoader(): void {
    this._loading.set(true);
  }

  hideLoader(): void {
    this._loading.set(false);
  }
}
